import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  policy: {
    vendor_id: undefined,
    product_id: undefined,
    trip_id: undefined,
    is_multi: false,
    self: true,
    country: 'US',
    state: '',
    dob: '',
    travelers: [{ 
      age: '', 
      cost: '', 
      dob: null, 
      name: '', 
      middle_name: '', 
      surname: '', 
      individual_trip_cost: '',
    }],
    destinations: [],
    start_date: null,
    end_date: null,
    benefits: [
      { id: 'benefit_1', value: false }, // If country_state is ‘IN’ benefit_1 (Medical Expense & Emergency Evacuation) is required
      { id: 'benefit_3', value: false },
      { id: 'benefit_5', value: true },
      // { id: 'benefit_6', value: false }, // 500000
      { id: 'benefit_8', value: false }, // Not available in NY
      { id: 'benefit_10', value: false },
      { id: 'benefit_12', value: false }, // 100000 | 250000 | 500000 If country_state is ‘FL’ at least one additional benefit is required if benefit_12 is enabled
      { id: 'benefit_15', value: false }, // Not available in NY (Included with Cancellation)
      { id: 'benefit_16', value: false },
      { id: 'benefit_17', value: false },
      { id: 'benefit_18', value: false }, // 1500 | 3000 | 5000
    ],
    number_of_reservations: 1,
    deposit_date: null,
    // benefit_6: 500000,
    benefit_12: 100000,
    benefit_18: 1500,

    coverage_limit: '3000', // multi
  },
}

const tripProtectionSlice = createSlice({
  name: 'tripProtection',
  initialState,
  reducers: {
    setPolicy: (state, action) => {
      state.policy = { ...state.policy, ...action.payload }
    },
    clearPolicy: state => {
      state.policy = initialState.policy
    },
  },
})

export const {
  setPolicy,
  clearPolicy,
} = tripProtectionSlice.actions

export default tripProtectionSlice.reducer
